import { Link, Navigate } from "react-router-dom";
import AdminShell from "../components/AdminShell";

const HUB_CARDS = [
  {
    to: "/admin/pricing",
    title: "App Pricing Management and Subscriptions",
    description: "Job prices, subscription packages, and country currencies.",
  },
  {
    to: "/admin/pricing/exchange-rates",
    title: "Exchange rates for job search",
    description: "Salary filter conversion rates — separate from job purchase pricing.",
  },
  {
    to: "/admin/users",
    title: "User management",
    description: "Search product accounts by email address.",
  },
  {
    to: "/admin/reports",
    title: "Reports",
    description: "Sign-up and platform metrics over time.",
  },
  {
    to: "/admin/audit",
    title: "Audit log",
    description: "Who changed pricing, accounts, and job posts — kept for 24 months.",
  },
  {
    to: "/admin/alerts",
    title: "Alerts",
    description: "Review open ops alerts and mark them complete.",
  },
];

export default function AdminHomePage({ currentUser, onSignOut }) {
  if (currentUser?.role !== "admin") {
    return <Navigate to="/admin/signin" replace />;
  }

  return (
    <AdminShell currentUser={currentUser} onSignOut={onSignOut}>
      <h1 className="jw-admin__title">Ops console</h1>
      <p className="jw-admin__lede">Pick a tool to get started.</p>

      <div className="jw-admin-hub">
        {HUB_CARDS.map((card) => (
          <Link key={card.to} to={card.to} className="jw-admin-hub-card">
            <h2 className="jw-admin-hub-card__title">{card.title}</h2>
            <p className="jw-admin-hub-card__desc">{card.description}</p>
            <span className="jw-admin-hub-card__cta">Open</span>
          </Link>
        ))}
      </div>
    </AdminShell>
  );
}
